import {
    DropdownListFormNotSelectedStringId,
    DropdownListItem,
} from "../../components/forms/dropdownListForm";
import {MultiSelectFormItem} from "../../components/forms/multiSelectForm";
import {AgeType} from "./newGroup";

export const dataForAge: Array<DropdownListItem> = [
    {name: "-----", id: DropdownListFormNotSelectedStringId},
    {name: "1", id: "1"},
    {name: "5", id: "5"},
    {name: "10", id: "10"},
    {name: "15", id: "15"},
    {name: "20", id: "20"},
    {name: "25", id: "25"},
    {name: "30", id: "30"},
    {name: "35", id: "35"},
    {name: "40", id: "40"},
    {name: "45", id: "45"},
    {name: "50", id: "50"},
    {name: "55", id: "55"},
    {name: "60", id: "60"},
    {name: "65", id: "65"},
    {name: "70", id: "70"},
]

export const dataForAgeType: Array<DropdownListItem> = [
    {name: "Years", id: "Y"},
    {name: "Months", id: "M"},
]

export const dataForGender: Array<DropdownListItem> = [
    {name: "-----", id: DropdownListFormNotSelectedStringId},
    {name: "Male", id: "M"},
    {name: "Female", id: "F"},
    {name: "Other", id: "U"},
]

// none = 0; Phone = 1; Mail= 2; Fax= 3; Email= 4; SMS= 5;
export const dataForPreferredContact: Array<DropdownListItem> = [
    {name: "-----", id: DropdownListFormNotSelectedStringId},
    {name: "Phone", id: 1},
    {name: "Mail", id: 2},
    {name: "Fax", id: 3},
    {name: "Email", id: 4},
    {name: "SMS", id: 5},
]

export const dataForPreferredLanguage: Array<DropdownListItem> = [
    {name: "-----", id: DropdownListFormNotSelectedStringId},
    {name: "English", id: "English"},
    {name: "Simplified Chinese", id: "Simplified Chinese"},
    {name: "Traditional Chinese", id: "Traditional Chinese"},
    {name: "Bengali", id: "Bengali"},
    {name: "Spanish", id: "Spanish"},
    {name: "Hindi", id: "Hindi"},
    {name: "Korean", id: "Korean"},
]

export const dataForChronicCondition: Array<MultiSelectFormItem> = [
    {name: "Diabetes", id: "Diabetes", isSelected: false},
    {name: "Hypertension", id: "Hypertension", isSelected: false},
    {name: "Asthma", id: "Asthma", isSelected: false},
    {name: "COPD", id: "COPD", isSelected: false},
]

export const dataForPatientPanel: Array<DropdownListItem> = [
    {name: "All", id: "CCACO/DSRIP"},
    {name: "CCACO", id: "CCACO"},
    {name: "DSRIP", id: "DSRIP"},
]

export const dataForPlanType: Array<DropdownListItem> = [
    {name: "-----", id: DropdownListFormNotSelectedStringId},
    {name: "Medicare", id: "MA"},
    {name: "Commercial", id: "HMO"},
    {name: "Commercial Medicare Advantage", id: "HMOMA"},
    {name: "Commercial Medicaid Advantage", id: "HMOMC"},
    {name: "Commercial Child Health Plus", id: "HMOCD"},
    {name: "Essential Plan", id: "Essential"},
    {name: "Medicare", id: "Obamacare"},
    {name: "Self-Pay", id: "Self-Pay"},
    {name: "OTHER", id: "OTHER"},
]

export enum LastDOS {
    lastWeek,
    last2Week,
    lastMonth,
    last2Months,
    last6Months,
    last12Months,
}

export const dataForLastDOS: Array<DropdownListItem> = [
    {name: "-----", id: DropdownListFormNotSelectedStringId},
    {name: "Last week", id: LastDOS.lastWeek},
    {name: "Last 2 weeks", id: LastDOS.last2Week},
    {name: "Last month", id: LastDOS.lastMonth},
    {name: "Last 2 months", id: LastDOS.last2Months},
    {name: "Last 6 months", id: LastDOS.last6Months},
    {name: "Last 12 months", id: LastDOS.last12Months},
]

export const getDefaultNewGroupSetting = () => {
    return {
        id: "",
        patientName: "",
        fromAge: "",
        toAge: "",
        ageType: AgeType.byYear,
        gender: DropdownListFormNotSelectedStringId,
        preferredContact: DropdownListFormNotSelectedStringId,
        preferredLanguage: DropdownListFormNotSelectedStringId,
        lastDOS: DropdownListFormNotSelectedStringId,
        dosFrom: null,
        dosTo: null,
        appointmentType: DropdownListFormNotSelectedStringId,
        chronicCondition: [],
        planType: DropdownListFormNotSelectedStringId,
        insurance: DropdownListFormNotSelectedStringId,
        insuranceName: "",
        icd: [],
        excludeIcd: [],
        cpt: [],
        excludeCpt: [],
        icdFrom: null,
        icdTo: null,
        cptFrom: null,
        cptTo: null,
        patientPanel: dataForPatientPanel[0].id,
        groupName: "",
    }
}
